<script setup lang="ts"></script>

<template>
  <icon name="lucide:arrow-left" />
</template>

<style scoped></style>
